import React from 'react';
import PropTypes from 'prop-types';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import {
  extend,
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { Skeleton, SkeletonContent, SkeletonLine } from '@one-thd/sui-atomic-components';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { DISPLAY_MODE_SALSIFY } from '../../constants';
import { Salsify } from './providers/Salsify';

const placeholder = (
  <Skeleton PaperProps={{
    className: 'sui-grow sui-border-0'
  }}
  >
    <SkeletonContent grow disableShrink initialSize="full" orientation="vertical">
      <SkeletonLine
        fullWidth
        numberOfLines={6}
      />
    </SkeletonContent>
  </Skeleton>
);

export const RichContentComponent = ({ itemId }) => {
  const { data, loading, error } = useDataModel('product', { variables: { itemId } });

  if (loading) {
    return (
      placeholder
    );
  }

  if (!data || error || !itemId) {
    return null;
  }

  const {
    richContent
  } = data?.product?.media || {};

  const displayMode = typeof richContent?.displayMode === 'string'
    ? richContent?.displayMode.toLowerCase() : richContent?.displayMode;

  const salsifyRichContent = richContent?.salsifyRichContent;

  const salsify = displayMode?.toLowerCase() === DISPLAY_MODE_SALSIFY;

  if (!richContent || !salsify) {
    return null;
  }

  return (
    <div className="sui-mb-8 sui-flex sui-flex-row sui-justify-center" data-testid="rich-content">
      {salsifyRichContent && (
        <Salsify salsifyRichContent={salsifyRichContent} parentId="salsify-key-features-summary" />
      )}
    </div>
  );
};

const dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    dataSources: stringType(),
    itemId: stringType(),
    media: shapeType({
      richContent: shapeType({
        content: stringType(),
        displayMode: stringType(),
        salsifyRichContent: stringType()
      })
    })
  })
};

const propTypes = {
  itemId: PropTypes.string.isRequired
};

RichContentComponent.displayName = 'RichContent';
RichContentComponent.dataModel = dataModel;
RichContentComponent.propTypes = propTypes;

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'product-section-rich-content',
  placeholder,
  scrollBuffer: 750
}, RichContentComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);
const RichContent = withErrorBoundary(DynamicComponent);

// RichContent.dataModel = dataModel;
// RichContent.propTypes = propTypes;
RichContent.displayName = 'RichContent';
export { RichContent };
